import { BaseService } from "./common/base";

type DispatchFindResult = {
  serviceRequests: any[];
  assistants: any[];
  doctors: any[];
};

export class DispatchService extends BaseService<
  any,
  any,
  any,
  any,
  any,
  DispatchFindResult
> {
  constructor() {
    super("dispatch");
  }

  find(): Promise<DispatchFindResult> {
    return super.find() as any;
  }

  assignPerformers(
    id: string,
    participants: { userType: string; id: string }[],
  ) {
    return super._post(`/assign-performers/${id}`, participants);
  }
}
